export const fromContacts = contacts =>
  contacts.map(contact => ({
    value: contact.id,
    label: contact.firstName + ' ' + contact.lastName,
    phone: contact.phone,
    email: contact.email,
    isMain: true,
    firstName: contact.firstName,
    lastName: contact.lastName,
    id: contact.id
  }))

export const toDealInternalTeam = team =>
  team?.map(t => ({
    ...t,
    role: {
      value: t.role.name,
      label: t.role.value
    }
  }))

export const toCompaniesWithTypes = companies =>
  companies.map(company => ({
    value: company.id,
    label: company.name
  }))
